/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function DiffModifiedInside({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12 12" {...props}><g clipPath="url(#DiffModifiedInside_svg__a)"><circle cx={6} cy={6} r={2} fill="currentColor" /><rect width={10} height={10} x={1} y={1} stroke="currentColor" rx={1} /></g><defs><clipPath id="DiffModifiedInside_svg__a"><path fill="#fff" d="M0 0h12v12H0z" /></clipPath></defs></svg>;
}
;